import { navigate, Link } from "gatsby"
import _ from "lodash"
import React, { useEffect } from "react"
import tw from "twin.macro"
import useTealiumView from "../../../../hooks/Tealium/useTealiumView"
import { ButtonLink } from "../../../atoms/Button"
import Icon from "../../../atoms/Icon"
import { SearchBar } from "../../SearchBar"
import { ThreeArrowAnimation } from "../../ThreeArrowAnimation"
import useTealiumEvent from "../../../../hooks/Tealium/useTealiumEvent"

const NotFoundOfferEs = () => {
  // Tealium
  const { handleTealView } = useTealiumView()
  const { trackTealEvent } = useTealiumEvent()
  useEffect(() => {
    handleTealView({
      page_name: "expired offer",
      page_type: "error",
      tealium_event: "expired_offer",
      error_message: `oops.... That Toyota Deal has expired`,
    })
  }, [])
  return (
    <div>
      <section
        css={[
          tw`min-h-[calc(100vh - 50px)] lg:min-h-[calc(100vh - 50px)] w-full bg-cover bg-no-repeat px-4 pt-8 bg-center lg:bg-bottom`,
          `background-image: url(../../../not_found_offer_bg_desktop.jpg)`,
          `@media (max-width: 660px) {
            background-image: url(../../../not_found_offer_bg_mobile.jpg);
          }`,
        ]}
      >
        <div css={tw`max-w-[1440px] mx-auto`}>
          <button
            css={[tw`flex items-center text-xs text-red-400 md:ml-10 lg:ml-24`]}
            onClick={() => navigate(-1)}
          >
            <Icon.Chevron
              color="red-400"
              direction="left"
              css={[tw`mr-1 w-2`]}
            />
            Regresar
          </button>
        </div>
        <div css={tw`max-w-xl mx-auto text-center pt-20`}>
          <div css={[tw`bg-opacity-80 bg-white rounded-xl p-6`]}>
            <h1 css={tw`text-red-400 font-semibold mb-2`}>
              ¡Ups! Esa oferta de Toyota ha expirado
            </h1>
            <h2
              css={[tw`text-2xl font-light mb-6 font-book`, tw`lg:(text-5xl)`]}
            >
              Explora todas nuestras ofertas Toyota actuales
            </h2>
            <p>
              Lamentamos que la oferta Toyota que estás buscando ya no está
              disponible, pero explora todas nuestras ofertas Toyota más
              actuales, ¡de seguro hay una para ti!
            </p>
          </div>
          <div css={tw`grid grid-cols-2 items-center gap-2 md:gap-6`}>
            <ButtonLink
              to="/es/offers"
              primary
              css={tw`w-auto`}
              onClick={() =>
                trackTealEvent({
                  tealium_event: "cta_click",
                  link_href: "/offers",
                  coupon_module_text: "All Toyota Offers",
                })
              }
              analytics-id={`All Toyota Offers:hero`}
            >
              Todas las ofertas Toyota
            </ButtonLink>
            <SearchBar mobileView={false} secondarySearchBar={true} />
          </div>
        </div>
      </section>
    </div>
  )
}

export default NotFoundOfferEs
